<template>
  <div class="order-container">
    <div
      class="look-account"
      v-if="orderList._status && orderList._status._type === 9"
    >
      <Button size="large" @click="modalAccount = true">查看收款账号</Button>
    </div>
    <!-- 当审核不通过时，才会出现以下模块 -->
    <div class="reason" v-if="orderList.isAgree === 2">
      <div class="title">
        <span class="refuse">拒绝原因：</span>
        <span>{{ orderList.remark }}</span>
      </div>
      <div class="img">
        <div class="title">重新上传处方和病历图片（共2张）</div>
        <upload-pic @getPrescriptionImg="getPrescriptionImg"></upload-pic>
      </div>
      <div class="new-btn">
        <Button type="primary" @click="commitPic">提交审核</Button>
      </div>
    </div>
    <StepNumber :current="stepIndex" align="right">
      <StepSon title="0.待审核"></StepSon>
      <StepSon title="1.待付款"></StepSon>
      <StepSon title="2.待发货"></StepSon>
      <StepSon title="3.待收货"></StepSon>
      <StepSon title="4.待评价"></StepSon>
      <StepSon title="5.已完成"></StepSon>
    </StepNumber>
    <div class="alert-box" v-if="orderList._status">
      <div>
        <Icon type="checkmark-circled icon-checkmark"></Icon
        >{{ orderList._status._msg }}
      </div>
      <div>{{ orderList._add_time }}</div>
    </div>
    <div class="table-box">
      <Table
        border
        ref="selection"
        :columns="columns"
        :data="shoppingCart"
        size="large"
        @on-row-click="rowClick"
      ></Table>
    </div>
    <div class="prescription-container">
      <h3>处方图片</h3>
      <div class="imgList">
        <div
          v-if="
            orderList.prescription_images &&
              orderList.prescription_images.length > 0
          "
        >
          <div
            class="item"
            v-for="(item, index) of orderList.prescription_images"
            :key="index"
            @click="scaleImg(index)"
          >
            <img :src="item" />
          </div>
        </div>
        <div v-else class="no-image">
          未上传处方图片
        </div>
      </div>
    </div>
    <div class="order-container">
      <h3>订单详情</h3>
    </div>
    <div class="project-box">
      <div class="left">
        <div>收货地址:</div>
        <div>订单编号:</div>
        <div>下单时间:</div>
        <div>订单类型:</div>
        <div>订单状态:</div>
        <div>支付方式:</div>
        <div>税费:</div>
      </div>
      <div class="right">
        <div v-if="orderList.shipping_type === 1">
          {{ orderList.user_address }} {{ orderList.real_name }}
          {{ orderList.user_phone }}
        </div>
        <div v-else>
          <template v-if="orderList.system_store">
            {{ orderList.system_store._detailed_address }}
            {{ orderList.system_store.name }} {{ orderList.system_store.phone }}
          </template>
        </div>
        <div>{{ orderList.order_id }}</div>
        <div>{{ orderList.add_time_y }} {{ orderList.add_time_h }}</div>
        <div>{{ orderTypeName }}</div>
        <div>{{ orderList._status && orderList._status._title }}</div>
        <div v-if="orderList._status">{{ orderList._status._payType }}</div>
        <div v-if="orderList.taxes_price">￥{{ orderList.taxes_price }}</div>
      </div>
    </div>
    <div
      class="express"
      v-if="orderList._status && orderList._status._title === '待收货'"
    >
      <div class="title">
        物流信息
      </div>
      <div class="body">
        <div class="item">
          <div class="left">
            物流公司：香港九州通
          </div>
          <div class="right">快遞公司：{{ orderList.delivery_name }}</div>
        </div>
        <div class="item">
          <div class="left">物流訂單編號：{{ orderList.delivery_id }}</div>
          <div class="right">
            快遞重量(KG)：{{ orderList.express.totalExpressWeight || 0 }}
          </div>
        </div>
        <div class="item">
          <div class="left">
            出庫稱重重量(KG)：{{ orderList.express.totalWeight || 0 }}
          </div>
          <div class="right">總體積(CBM)：{{ orderList.express.totalVol }}</div>
        </div>
        <div class="item">
          <div class="left">總數量：{{ orderList.express.totalQty }}</div>
          <div class="right">訂單狀態：{{ orderList.express.orderStatus }}</div>
        </div>
        <div class="item">
          <div class="left">
            快遞單號：{{ orderList.delivery_id }}|<button
              v-if="orderList.delivery_id"
              @click="goToExpress(orderList.order_id)"
            >
              物流查詢
            </button>
          </div>
          <div class="right">清關單號/提單號：{{ orderList.express.blNo }}</div>
        </div>
      </div>
    </div>
    <div
      class="order-container pay-method"
      v-if="orderList._status && orderList._status._type === 0"
    >
      <h3>请选择付款方式</h3>
    </div>
    <div class="pay-container" v-if="stepIndex === 1">
      <div class="pay-box" v-if="orderList.isAgree === 1">
        <div
          class="pay-list"
          v-if="orderList._status && orderList._status._type !== 9"
        >
          <!-- <div
            class="item"
            :class="payType === 'weixin' ? 'active' : ''"
            @click="changePayType('weixin')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/weixin.png" alt="" />
              微信支付
            </div>
            <div class="right">微信快捷支付</div>
          </div> -->
          <div
            class="item"
            :class="payType === 'alipay' ? 'active' : ''"
            @click="changePayType('alipay')"
          >
            <div class="left">
              <img src="@/assets/pc/images/pay/alipay.png" alt="" />
              支付宝支付
            </div>
            <div class="right">支付宝快捷支付</div>
          </div>
          <!-- <div
            class="item"
            :class="payType === 'yue' ? 'active' : ''"
            @click="changePayType('yue')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/pay.png" alt="" />
              余额支付
            </div>
            <div class="right">可用余额: {{ nowMoney }}</div>
          </div> -->
          <!-- <div
            class="item"
            :class="payType === 'offline' ? 'active' : ''"
            @click="changePayType('offline')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/offline.png" alt="" />
              线下支付
            </div>
            <div class="right">线下方便支付</div>
          </div> -->
        </div>
        <p class="allMonkey">
          <span>订单应付总额：</span>
          <span class="money">￥{{ orderList.pay_price }}</span>
        </p>
        <div
          class="pay-btn"
          @click="commitOrder"
          v-if="orderList._status && orderList._status._type !== 9"
        >
          <Button type="error" size="large">立即付款</Button>
        </div>
      </div>
    </div>
    <div class="pay-container" v-else>
      <div class="pay-box">
        <p class="allMonkey">
          <span>订单实付总额：</span>
          <span class="money">
            <Icon type="social-yen"></Icon>{{ orderList.pay_price }}
          </span>
        </p>
      </div>
    </div>
    <Modal v-model="modalImg" title="图片放大">
      <div class="bigImage">
        <img :src="bigImage" />
      </div>
    </Modal>
    <Modal
      v-model="modalAccount"
      title="收款账号"
      center
      @on-ok="modalAccount = false"
    >
      <div class="account-detail">
        <div class="item">
          <div>
            Bank Name：INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MACAU) LIMITED
          </div>
          <div>银行名称: 中国工商银行(澳门)有限公司</div>
        </div>
        <div class="item">
          <div>SWITF CODE : ICBKMOMX</div>
          <div>SWITF代码: ICBKMOMX</div>
        </div>
        <div class="item">
          <div>BANK ADDRESS: 18/F,MACAU LANDMARK,555 AV.DA AMIZADE ,MACAU</div>
          <div>银行地址: 澳门友谊大道555号澳门地标18楼</div>
        </div>
        <div class="item">
          <div>ACCOUNT NAME: WUZHOU DRUG INTERNATIONAL TRADING LIMITED</div>
          <div>账户名称: 五洲药物国际贸易有限公司</div>
        </div>
        <div class="item">
          <div>ACCOUNT NO:0119100600004306067</div>
          <div>账号: 0119100600004306067</div>
        </div>
      </div>
    </Modal>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="title" v-if="payType === 'weixin' || payType === 'alipay'">
          <img src="/assets/pc/images/pay/success.png" alt="" />
          <span class="success">付款二维码生成中</span>
        </div>
        <div class="title" v-else>
          <img src="/assets/pc/images/pay/loading.png" alt="" class="laoding" />
          <span class="success">订单处理中</span>
        </div>
        <div class="time">请稍等...</div>
      </div>
    </div>
    <PayForm :config="config" ref="payForm"></PayForm>
  </div>
</template>
<script>
import UploadPic from "@/components/pc/authenticate/UploadPic";
import PayForm from "@/components/pc/order/PayForm";
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepSon from "@/components/pc/commonTool/Steps/StepSon";
import { orderDetail, payOrder } from "@api/order";
import { getUserInfo, changePrescriptionImage } from "@api/user";
export default {
  name: "OrderDetail",
  components: {
    UploadPic,
    PayForm,
    StepNumber,
    StepSon
  },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 58,
          align: "center"
        },
        {
          title: "图片",
          key: "img",
          width: 86,
          render: (h, params) => {
            return h("div", [
              h("img", {
                attrs: {
                  src: params.row.img
                }
              })
            ]);
          },
          align: "center"
        },
        {
          title: "标题",
          key: "title",
          align: "center"
        },
        {
          title: "属性",
          width: 198,
          key: "package",
          align: "center"
        },
        {
          title: "数量",
          key: "count",
          width: 68,
          align: "center"
        },
        {
          title: "价格",
          width: 100,
          key: "price",
          align: "center"
        }
      ],
      orderList: {},
      shoppingCart: [],
      orderTypeName: "普通订单",
      payType: "alipay",
      nowMoney: 0,
      uniId: "",
      stepIndex: 5,
      modalImg: false,
      bigImage: "",
      imageList: [],
      modalAccount: false,
      maskShow: false,
      config: {} // unionpay支付所需的参数
    };
  },
  created() {
    this.getOrderInfo();
    getUserInfo().then(res => {
      this.nowMoney = res.data.now_money;
    });
  },
  methods: {
    getOrderInfo() {
      this.uniId = this.$route.params.id;
      orderDetail(this.uniId)
        .then(res => {
          this.orderList = res.data;
          if (res.data._status._type === 9) {
            this.stepIndex = 1;
          } else {
            this.stepIndex = res.data._status._type + 1; // 步骤序号
            if (res.data._status._type == 5) {
              this.stepIndex = 0;
            }
          }
          res.data.cartInfo.forEach(item => {
            item.img = item.productInfo.image;
            item.title = item.productInfo.store_name;
            if (item.productInfo.attrInfo) {
              item.package = item.productInfo.attrInfo.suk;
            }
            item.count = item.cart_num;
            item.price = item.truePrice;
            this.shoppingCart.push(item);
          });
          if (this.orderList.combination_id > 0) {
            this.orderTypeName = "拼团订单";
          } else if (this.orderList.bargain_id > 0) {
            this.orderTypeName = "砍价订单";
          } else if (this.orderList.seckill_id > 0) {
            this.orderTypeName = "秒杀订单";
          }
        })
        .catch(err => {
          if (err.msg === "订单不存在") {
            this.$router.push({
              path: "/home/myOrder"
            });
          }
        });
    },
    changePayType(type) {
      this.payType = type;
      if (type === "offline") {
        this.modalAccount = true;
      } else {
        this.modalAccount = false;
      }
    },
    commitOrder() {
      // 先判断订单时间是否过期了
      const addOrderTime = new Date(this.orderList._add_time); // 订单添加的时间
      const passOrderTimeNum = addOrderTime.setDate(addOrderTime.getDate() + 1); // 订单过期时间的毫秒数
      const nowTimeNum = new Date().getTime();
      if (nowTimeNum > passOrderTimeNum) {
        this.$Modal.warning({
          content: "您的订单已过期，请重新下单"
        });
        return;
      }
      if (this.payType === "weixin" || this.payType === "alipay") {
        // 微信支付
        this.maskShow = true;
        const method = this.payType == "weixin" ? "weixin" : "zhifubao";
        payOrder(this.uniId, this.payType, "weixinpc")
          .then(res => {
            if (res.status === 200) {
              const img = res.data.result.jsConfig.results.codeUrl
                ? res.data.result.jsConfig.results.codeUrl
                : res.data.result.jsConfig.results.payUrl;
              const orderId = res.data.result.jsConfig.results.order_id
                ? res.data.result.jsConfig.results.order_id
                : res.data.result.jsConfig.results.orderNo;
              this.$router.push({
                name: "Pay",
                params: { img, orderId, method }
              });
              this.maskShow = false;
            }
          })
          .catch(err => {
            this.maskShow = false;
            this.$Modal.warning({
              content: err.msg
            });
          });
      } else if (this.payType === "unionpay") {
        this.maskShow = true;
        payOrder(this.uniId, this.payType, "unionpc")
          .then(res => {
            if (res.status === 200) {
              const resData = res.data;
              if (resData.status === "UNION_H5_PAY") {
                this.config = resData.result.jsConfig;
                this.$refs.payForm.goPay();
                this.maskShow = false;
              }
            }
          })
          .catch(err => {
            this.maskShow = false;
            this.$Modal.warning({
              content: err.msg
            });
          });
      } else {
        this.maskShow = true;
        payOrder(this.uniId, this.payType, "weixinh5")
          .then(res => {
            if (res.status === 200) {
              const resData = res.data;
              if (resData.status === "SUCCESS") {
                this.$router.go(0);
                this.maskShow = false;
              }
            }
          })
          .catch(err => {
            this.maskShow = false;
            this.$Modal.warning({
              content: err.msg
            });
          });
      }
    },
    scaleImg(index) {
      this.modalImg = true;
      this.bigImage = this.orderList.prescription_images[index];
    },
    getPrescriptionImg(fileList) {
      this.imageList = fileList;
    },
    commitPic() {
      if (this.imageList.length < 2) {
        this.$Message.error("需提供处方和病历，共2张图片");
        return;
      }
      const params = {
        order_id: this.orderList.order_id,
        imageList: this.imageList
      };
      changePrescriptionImage(params).then(res => {
        if (res.status === 200) {
          this.$Message.success("提交成功");
          this.getOrderInfo();
        }
      });
    },
    rowClick(e) {
      this.$router.push({
        path: "/goodsDetail/" + e.product_id
      });
    },
    goToExpress(id) {
      this.$router.push({
        path: `/home/expressInfo/${id}`
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.order-container /deep/ .ivu-table-cell
  img
    width 100%
  >div
    padding-top 10px
    padding-bottom 10px

.look-account
  text-align center
  margin-bottom 20px

.alert-box
  background #f3fded
  color #999
  border-radius 4px
  padding 10px 20px
  font-size 12px
  margin 20px 0
  opacity 0.9
  div
    &:first-child
      font-size 14px
      font-weight 600
      color #7abd5d
      .icon-checkmark
        margin-right 10px
        font-size 18px
        transform translateY(2px)
    &:last-child
      margin-left 25px

.table-box
  margin-top 20px

.prescription-container
  margin 15px 0
  h3
    margin-bottom 10px
    font-size 14px
  .imgList
    overflow-x auto
    white-space nowrap
    .item
      display inline-block
      width 150px
      height 150px
      margin-right 10px
      img
        width 100%
        height 100%
    .no-image
      text-indent 10px


.order-container
  h3
    font-size 15px
  &.pay-method
    margin-top 20px

.project-box
  background #f8f8f9
  margin-top 10px
  padding 10px 20px
  display flex
  .left
    line-height 30px
    font-size 13px
    font-weight 700
    color #666
    font-family 'Microsoft YaHei'
    margin-right 20px
  .right
    line-height 30px
    font-size 13px
    color #999
.express
  width:100%
  margin-top:15px
  border:2px rgb(245,245,245) solid
  border-radius:2px
  .title
    background-color:rgb(245,245,245)
    padding:5px
  .item
    display:flex
    align-items:center
    font-size:14px
    padding:5px
    .left,.right
      width:50%
      border-bottom:1px rgb(245,245,245) solid
      button
        font-size:12px
        background-color:rgb(0,146,220)
        padding:2px 4px
        color:#fff
        border-radius:5px
        cursor:pointer
.pay-container
  margin 15px 0
  display flex
  justify-content flex-end
  .pay-box
    font-size 18px
    font-weight bolder
    color #495060
    width 100%
    .pay-list
      display flex
      justify-content space-between
      .item
        display flex
        justify-content space-between
        border 1px solid #dedede
        font-size 14px
        font-weight normal
        padding 5px
        margin-bottom 10px
        cursor pointer
        width 32%
        &.active
          border 1px solid #ff7a7a
          animation rainbow 1s ease
        .left
        .right
          width 50%
          text-align: center
        .left
          border-right 1px solid #eee
          img
            width 18px
            height 18px
            position relative
            top 4px
        .right
          color #9b9b9b
    .allMonkey
      margin-top 30px
      text-align right
      font-family 'Microsoft yahei'
      .money
        font-size 26px
        color #f90013

.pay-btn
  margin 15px 0px
  display flex
  justify-content flex-end

.bigImage
  img
    width 100%

.reason
  padding 20px 20px
  border 1px dashed red
  margin-bottom 20px
  .title
    .refuse
      font-size 14px
      font-weight 600
      color #333
  .img
    .title
      font-size 14px
      color #666
      margin 20px 0 5px
  .new-btn
    margin-top 10px

.account-detail
  .item
    margin-bottom 10px
    padding-bottom 10px
    border-bottom 1px dashed rgb(182, 182, 182)
    &:last-child
      border none
      margin 0
      padding 0
    div
      &:first-child
        font-size 14px
        font-weight 550
        color #666
        margin-bottom 5px

.mask
  position fixed
  top: 0
  background rgba(0, 0, 0, .5)
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  justify-content center
  z-index 999
  .content
    width 300px
    height 150px
    background #fff
    padding 30px
    border-radius 8px
    .title
      text-align center
      .laoding
        animation:turn 2s linear infinite
      img
        width 24px
        height 24px
        display inline-block
        position relative
        top 6px
      .success
        font-size 18px
        margin-left 5px
  .time
    margin-top 25px
    text-align center
    font-size 14px

@keyframes turn
  0%
    -webkit-transform rotate(0deg)
  25%
    -webkit-transform rotate(90deg)
  50%
    -webkit-transform rotate(180deg)
  75%
    -webkit-transform rotate(270deg)
  100%
    -webkit-transform rotate(360deg)
@keyframes rainbow
  50%
    transform: scale(1.1)

  100%
    transform scale(1)
</style>
